@import 'styles/variables';
@import 'styles/mixins';

.tabs {
  display: flex;
  position: relative;
  gap: 2px;
  padding: 0;
}

.tabsContainer {
  overflow-y: hidden;

  @include for-phone-only {
    background-color: var(--editor-top);
  }
}

.tabContentsContainer {
  width: 100%;
  overflow-x: clip;
  height: 100%;

  &.animate {
    .tabsContainerInner {
      transition: transform 0.2s ease-in-out;
    }
  }
}

.tabsContainerInner {
  background-color: transparent;
  height: 100%;
}

.tabContent {
  background-color: var(--light-60);
  padding: 28px;
  min-height: 350px;
  display: inline-block;
  vertical-align: top;

  @include for-phone-only {
    padding: 20px 15px;
  }
}

.tabItem {
  flex: 1;
  max-width: 250px;
  display: flex;
}

.tabDivider {
  width: 1px;
  background-color: var(--dark-8);
  margin: 6px 2px;
  height: 32px;

  &.hidden {
    background-color: transparent;
  }
}
